// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorView_container__5JO1D","footerActions":"ErrorView_footerActions__U6Mgp"};